import React, { useEffect, useState, lazy, Suspense } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./Home.css";
//import heroBg from "../assets/17973908.jpg";
import img700 from "../assets/Screenshot (700).png";
import img703 from "../assets/Screenshot (703).png";
import img704 from "../assets/Screenshot (704).png";
import img706 from "../assets/Screenshot (706).png";
import img707 from "../assets/Screenshot (707).png";
import img708 from "../assets/Screenshot (708).png";
import img709 from "../assets/Screenshot (709).png";
import imgWeb from "../assets/1904.i402.013..Web development isometric concept composition.jpg";
import heroBg from "../assets/vecteezy_technology-background-and-computer-circuit-board_10742655.jpg";
import imgCloud from "../assets/10354235_4428861.jpg";
import expertiseBg from "../assets/Software Company Development.jpg";
//import footerBg from "../assets/Footer.webp";

// Import the stock image directly
import stockImage from "../assets/stock1.jpg";

// Optimized image URLs with compression and WebP format
const carouselImages = [
  {
    src: "https://res.cloudinary.com/dplqjwnoc/image/upload/c_scale,w_800,f_webp,q_auto/v1737436780/cloud-computing-2001090_pexu86.jpg",
    header: "Cloud Innovation",
    fallback:
      "https://res.cloudinary.com/dplqjwnoc/image/upload/c_scale,w_800,q_auto/v1737436780/cloud-computing-2001090_pexu86.jpg",
  },
  {
    src: "https://res.cloudinary.com/dplqjwnoc/image/upload/c_scale,w_800,f_webp,q_auto/v1737437153/digital-marketing-1725340_derbba.jpg",
    header: "Digital Transformation",
    fallback:
      "https://res.cloudinary.com/dplqjwnoc/image/upload/c_scale,w_800,q_auto/v1737437153/digital-marketing-1725340_derbba.jpg",
  },
  {
    src: "https://res.cloudinary.com/dplqjwnoc/image/upload/c_scale,w_800,f_webp,q_auto/v1737436793/ai-generated-8540913_uzparo.jpg",
    header: "AI Solutions",
    fallback:
      "https://res.cloudinary.com/dplqjwnoc/image/upload/c_scale,w_800,q_auto/v1737436793/ai-generated-8540913_uzparo.jpg",
  },
  {
    src: "https://res.cloudinary.com/dplqjwnoc/image/upload/c_scale,w_800,f_webp,q_auto/v1737436762/technology-8760347_n8gk0j.jpg",
    header: "Secure Infrastructure",
    fallback:
      "https://res.cloudinary.com/dplqjwnoc/image/upload/c_scale,w_800,q_auto/v1737436762/technology-8760347_n8gk0j.jpg",
  },
  {
    src: "https://res.cloudinary.com/dplqjwnoc/image/upload/c_scale,w_800,f_webp,q_auto/v1737437063/startup-594090_l2km65.jpg",
    header: "Business Optimization",
    fallback:
      "https://res.cloudinary.com/dplqjwnoc/image/upload/c_scale,w_800,q_auto/v1737437063/startup-594090_l2km65.jpg",
  },
];

// Real images for Our Expertise
const expertiseItems = [
  {
    title: "Cloud Computing & DevOps",
    img: img700,
  },
  {
    title: "Web & Mobile App Development",
    img: imgCloud,
  },
  {
    title: "Custom Software Development",
    img: imgWeb,
  },
  {
    title: "AI & ML",
    img: img703,
  },
  {
    title: "Cybersecurity",
    img: img704,
  },
  {
    title: "ERP & CRM",
    img: img706,
  },
  {
    title: "Atlassian Solutions",
    img: img707,
  },
  {
    title: "Digital Marketing",
    img: img708,
  },
  {
    title: "Generative AI",
    img: img709,
  },
];

// Loading component
const LoadingSpinner = () => (
  <div className="home-loading-spinner">
    <div className="home-spinner"></div>
  </div>
);

// Optimized Image Component with WebP support and better error handling
const OptimizedImage = ({ src, fallback, alt, className, ...props }) => {
  const [imageSrc, setImageSrc] = useState(src);
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  const handleError = () => {
    if (!hasError && fallback && fallback !== imageSrc) {
      setImageSrc(fallback);
      setHasError(true);
    }
  };

  const handleLoad = () => {
    setIsLoaded(true);
  };

  if (fallback && fallback !== src) {
    return (
      <picture>
        <source srcSet={src} type="image/webp" />
        <img
          src={imageSrc}
          alt={alt}
          className={`${className} ${
            isLoaded ? "home-image-loaded" : "home-image-loading"
          }`}
          onError={handleError}
          onLoad={handleLoad}
          loading="lazy"
          {...props}
        />
      </picture>
    );
  }

  return (
    <img
      src={imageSrc}
      alt={alt}
      className={`${className} ${
        isLoaded ? "home-image-loaded" : "home-image-loading"
      }`}
      onError={handleError}
      onLoad={handleLoad}
      loading="lazy"
      {...props}
    />
  );
};

const Home = () => {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [gsapLoaded, setGsapLoaded] = useState(false);
  const [motionLoaded, setMotionLoaded] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  // Track scroll position
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Preload critical resources
  useEffect(() => {
    const imageLink = document.createElement("link");
    imageLink.rel = "preload";
    imageLink.as = "image";
    imageLink.href = carouselImages[0].src;
    document.head.appendChild(imageLink);

    return () => {
      if (document.head.contains(imageLink))
        document.head.removeChild(imageLink);
    };
  }, []);

  // Load GSAP only when needed
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !gsapLoaded) {
            loadGSAP();
          }
        });
      },
      { threshold: 0.1 },
    );

    const heroSection = document.querySelector(".home-hero-section");
    if (heroSection) {
      observer.observe(heroSection);
    }

    return () => observer.disconnect();
  }, [gsapLoaded]);

  // Load Framer Motion when needed
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !motionLoaded) {
            loadFramerMotion();
          }
        });
      },
      { threshold: 0.1 },
    );

    const aboutSection = document.querySelector(".home-about-section");
    if (aboutSection) {
      observer.observe(aboutSection);
    }

    return () => observer.disconnect();
  }, [motionLoaded]);

  const loadGSAP = async () => {
    try {
      const [gsapModule, scrollTriggerModule] = await Promise.all([
        import("gsap"),
        import("gsap/ScrollTrigger"),
      ]);

      const gsap = gsapModule.gsap;
      const ScrollTrigger = scrollTriggerModule.ScrollTrigger;

      gsap.registerPlugin(ScrollTrigger);
      setGsapLoaded(true);

      initializeAnimations(gsap, ScrollTrigger);
    } catch (error) {
      console.error("Failed to load GSAP:", error);
    }
  };

  const loadFramerMotion = async () => {
    try {
      await import("framer-motion");
      setMotionLoaded(true);
    } catch (error) {
      console.error("Failed to load Framer Motion:", error);
    }
  };

  const initializeAnimations = (gsap, ScrollTrigger) => {
    // Hero section animations
    gsap.fromTo(
      ".home-hero-title",
      { opacity: 0, y: 30 },
      { opacity: 1, y: 0, duration: 1, ease: "power3.out" },
    );
    gsap.fromTo(
      ".home-hero-description",
      { opacity: 0, y: 20 },
      { opacity: 1, y: 0, duration: 1, delay: 0.3, ease: "power3.out" },
    );
    gsap.fromTo(
      ".home-hero-button",
      { opacity: 0, scale: 0.8 },
      {
        opacity: 1,
        scale: 1,
        duration: 0.8,
        delay: 0.6,
        ease: "back.out(1.7)",
      },
    );

    // Scroll-triggered animations for sections
    gsap.utils.toArray(".home-fade-in").forEach((section) => {
      gsap.fromTo(
        section,
        { opacity: 0, y: 60 },
        {
          opacity: 1,
          y: 0,
          duration: 1.2,
          ease: "power3.out",
          scrollTrigger: {
            trigger: section,
            start: "top 85%",
            toggleActions: "play none none reverse",
          },
        },
      );
    });

    // Stagger animation for expertise items
    gsap.utils.toArray(".home-service-item").forEach((item, index) => {
      gsap.fromTo(
        item,
        { opacity: 0, y: 40, scale: 0.95 },
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.8,
          delay: index * 0.1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: item,
            start: "top 90%",
            toggleActions: "play none none reverse",
          },
        },
      );
    });
  };

  // Optimized carousel
  useEffect(() => {
    const carouselInterval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
    }, 4000);

    return () => clearInterval(carouselInterval);
  }, []);

  const handleDiscoverClick = () => {
    navigate("/what-we-do");
  };

  const handleContactClick = () => {
    navigate("/contact");
  };

  // Dynamic motion component
  const MotionComponent = ({ children, ...props }) => {
    if (!motionLoaded) {
      return <div {...props}>{children}</div>;
    }

    const { motion } = require("framer-motion");
    return React.createElement(motion.div, props, children);
  };

  const MotionH2 = ({ children, ...props }) => {
    if (!motionLoaded) {
      return <h2 className={props.className}>{children}</h2>;
    }

    const { motion } = require("framer-motion");
    return React.createElement(motion.h2, props, children);
  };

  const MotionP = ({ children, ...props }) => {
    if (!motionLoaded) {
      return <p className={props.className}>{children}</p>;
    }

    const { motion } = require("framer-motion");
    return React.createElement(motion.p, props, children);
  };

  return (
    <div className="home-container">
      <Helmet>
        <style type="text/css">{`
          .home-hero-section { min-height: 100vh; position: relative; }
          .home-loading-spinner { display: flex; justify-content: center; align-items: center; height: 200px; }
          .home-spinner { width: 40px; height: 40px; border: 4px solid #f3f3f3; border-top: 4px solid #6366f1; border-radius: 50%; animation: spin 1s linear infinite; }
          @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
          .home-image-loading { opacity: 0; transition: opacity 0.3s; }
          .home-image-loaded { opacity: 1; }
          .home-about-image { width: 100%; height: auto; border-radius: 20px; }
          .home-about-image-container { display: flex; justify-content: center; align-items: center; }
        `}</style>

        <title>DB4Cloud Technologies - Digital & Cloud Solutions</title>
        <meta
          name="description"
          content="DB4Cloud Technologies delivers cutting-edge cloud computing, AI/ML, custom software development, and digital transformation solutions."
        />
        <meta
          name="keywords"
          content="DB4Cloud delivers cutting-edge cloud, AI/ML, and software solutions to transform businesses with innovative digital services."
        />
        <meta name="author" content="DB4Cloud" />
        <link rel="canonical" href="https://db4cloud.in" />

        <link rel="preload" href={carouselImages[0].src} as="image" />
        <link rel="dns-prefetch" href="//res.cloudinary.com" />
        <link
          rel="preconnect"
          href="https://res.cloudinary.com"
          crossOrigin="anonymous"
        />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="DB4Cloud Technologies" />
        <meta
          property="og:title"
          content="DB4Cloud - Leading Technology Solutions Provider"
        />
        <meta
          property="og:description"
          content="Empowering businesses with innovative cloud solutions, AI/ML, custom software development, and digital transformation services."
        />
        <meta property="og:url" content="https://db4cloud.in" />
        <meta
          property="og:image"
          content="https://db4cloud.in/images/home-banner.jpg"
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@DB4Cloud" />
        <meta
          name="twitter:title"
          content="DB4Cloud Technologies - Innovation Meets Excellence"
        />
        <meta
          name="twitter:description"
          content="Your partner in digital transformation. Expert solutions in cloud computing, AI/ML, software development, and cybersecurity."
        />
        <meta
          name="twitter:image"
          content="https://db4cloud.in/images/home-banner.jpg"
        />

        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="language" content="English" />
        <meta name="revisit-after" content="7 days" />
        <meta name="generator" content="React" />

        <script type="application/ld+json">
          {`
            {
              "@context": "http://schema.org",
              "@type": "Organization",
              "name": "DB4Cloud Technologies",
              "url": "https://db4cloud.in",
              "logo": "https://db4cloud.in/images/logo.png",
              "description": "Leading provider of cloud computing, AI/ML, and digital transformation solutions",
              "sameAs": [
                "https://www.linkedin.com/company/db4cloud",
                "https://twitter.com/DB4Cloud"
              ],
              "address": {
                "@type": "PostalAddress",
                "addressCountry": "India"
              },
              "contactPoint": {
                "@type": "ContactPoint",
                "contactType": "customer support",
                "email": "contact@db4cloud.in"
              }
            }
          `}
        </script>
      </Helmet>

      {/* Hero Section */}
      <section className="home-hero-section">
        <div className="home-hero-background"></div>
        <div className="home-hero-particles">
          <div className="particle"></div>
          <div className="particle"></div>
          <div className="particle"></div>
          <div className="particle"></div>
          <div className="particle"></div>
        </div>
        <div className="home-hero-content">
          <div className="home-hero-badge">
            <span className="badge-dot"></span>
            Leading Technology Solutions
          </div>
          <h1 className="home-hero-title">Welcome to DB4Cloud Technologies</h1>
          <p className="home-hero-description">
            Empowering businesses with innovative technology solutions.
          </p>
          <div className="home-hero-buttons">
            <button
              className="home-hero-button primary"
              onClick={handleDiscoverClick}
            >
              <span>Discover More</span>
              <svg
                className="button-icon"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M7.5 15L12.5 10L7.5 5"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            <button
              className="home-hero-button secondary"
              onClick={handleContactClick}
            >
              <span>Contact Us</span>

              <svg
                className="button-icon"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M7.5 15L12.5 10L7.5 5"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>
        {/* <div className="home-hero-scroll-indicator">
          <div className="scroll-mouse">
            <div className="scroll-wheel"></div>
          </div>
          <span className="scroll-text">Scroll to explore</span>
        </div> */}
      </section>

      {/* About Us Section */}
      <section className="home-section home-fade-in">
        <div className="home-about-section">
          <div className="home-about-content">
            <div className="home-section-label">About Us</div>
            <MotionH2
              className="home-about-title"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              Transforming Businesses Through Technology
            </MotionH2>

            <MotionP
              className="home-about-text"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.3 }}
            >
              At DB4Cloud Technologies, we specialize in delivering custom
              software and technological solutions that transform businesses.
              With a passionate team of experts, we prioritize client
              satisfaction and innovation. We help businesses scale, optimize
              their operations, and leverage cutting-edge technologies such as
              AI, Cloud, and IoT.
            </MotionP>

            <MotionP
              className="home-about-text"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
            >
              With over a decade of experience, our team has successfully helped
              numerous clients across various industries achieve their digital
              transformation goals. Whether you're a startup or an established
              enterprise, our solutions are designed to meet your unique needs
              and drive your business forward.
            </MotionP>

            <div className="home-about-stats">
              <div className="stat-item">
                <span className="stat-number">2+</span>
                <span className="stat-label">Years Experience</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">4+</span>
                <span className="stat-label">Projects Delivered</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">15+</span>
                <span className="stat-label">Happy Clients</span>
              </div>
            </div>
          </div>

          <MotionComponent
            className="home-about-image-container"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <div className="home-about-image-wrapper">
              <img
                src={stockImage}
                alt="About DB4Cloud Technologies - Team working on innovative technology solutions"
                className="home-about-image"
                loading="lazy"
                onError={(e) => {
                  console.error("Image failed to load:", e.target.src);
                  e.target.src =
                    "https://via.placeholder.com/600x400/6366f1/white?text=DB4Cloud+Technologies";
                }}
              />
              <div className="home-about-image-decoration"></div>
            </div>
          </MotionComponent>
        </div>
      </section>

      {/* Image Carousel Section */}
      <section className="home-section home-fade-in home-carousel-section">
        <div className="home-section-label">Our Journey</div>
        <MotionH2
          className="home-carousel-title"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Innovation in Motion
        </MotionH2>

        <div className="home-carousel-container">
          {carouselImages.map((image, index) => (
            <MotionComponent
              key={index}
              className={`home-carousel-slide ${
                index === currentSlide ? "active" : "inactive"
              }`}
              initial={{ opacity: 0 }}
              animate={{
                opacity: index === currentSlide ? 1 : 0,
                scale: index === currentSlide ? 1 : 1.05,
              }}
              transition={{ duration: 0.8, ease: "easeInOut" }}
            >
              <OptimizedImage
                src={image.src}
                fallback={image.fallback}
                alt={image.header}
                className="home-carousel-image"
              />
              <div className="home-carousel-overlay"></div>
              <div className="home-carousel-caption">
                <h3 className="home-carousel-caption-title">{image.header}</h3>
                <div className="home-carousel-caption-line"></div>
              </div>
            </MotionComponent>
          ))}

          <div className="home-carousel-dots">
            {carouselImages.map((_, index) => (
              <button
                key={index}
                className={`carousel-dot ${index === currentSlide ? "active" : ""}`}
                onClick={() => setCurrentSlide(index)}
                aria-label={`Go to slide ${index + 1}`}
              ></button>
            ))}
          </div>
        </div>
      </section>

      {/* Our Expertise Section */}
      <section
        className="home-section home-fade-in home-expertise-section"
        style={{
          backgroundImage: `url(${expertiseBg})`,
        }}
      >
        <div className="home-section-label">Our Expertise</div>
        <h2 className="home-expertise-title">What We Do Best</h2>
        <div className="home-expertise-grid">
          {expertiseItems.map((item, index) => (
            <div className="home-service-item" key={index}>
              <div className="home-service-icon-wrapper">
                <img
                  src={item.img}
                  alt={item.title}
                  className="home-service-icon"
                  loading="lazy"
                  onError={(e) => {
                    console.log("Error loading:", e.target.src);
                    e.target.src =
                      "https://via.placeholder.com/80x80/6366f1/ffffff?text=DB";
                  }}
                />
              </div>
              <h3 className="home-service-title">{item.title}</h3>
              <p className="home-service-text">
                Expert solutions tailored to your business needs
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* Get in Touch Section */}
      <section className="home-section home-fade-in home-contact-section">
        <div className="home-contact-content">
          <div className="home-section-label">Get in Touch</div>
          <MotionH2
            className="home-contact-title"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            Ready to Transform Your Business?
          </MotionH2>

          <MotionP
            className="home-contact-text"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Ready to bring your vision to life? Contact us today and let's
            discuss how we can help your business grow and innovate.
          </MotionP>

          <div className="home-contact-button-container">
            <button
              className="home-contact-button"
              onClick={handleContactClick}
            >
              <span>Contact Us</span>
              <svg
                className="button-icon"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M7.5 15L12.5 10L7.5 5"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>
        <div className="home-contact-decoration">
          <div className="decoration-circle circle-1"></div>
          <div className="decoration-circle circle-2"></div>
          <div className="decoration-circle circle-3"></div>
        </div>
      </section>
    </div>
  );
};

export default Home;
